module.exports = __webpack_public_path__ + "static/media/free_text.6fd3565d.jpg";